import { Controller } from "@hotwired/stimulus"

/**
 * Generischer Dialog-Loader: Lädt HTML per fetch und zeigt es in einem nativen <dialog>.
 *
 * Verwendung:
 *   %button{ data: { controller: 'dialog-loader',
 *                     dialog_loader_url_value: '/backend/contacts/42/compose_email',
 *                     action: 'click->dialog-loader#open' } }
 *     📧 Email
 *
 * Der Controller erstellt ein <dialog> Element im <body>, lädt den Inhalt
 * per fetch und öffnet es mit showModal(). Escape oder Backdrop-Klick schließt.
 */
export default class extends Controller {
  static values = { url: String }

  open(event) {
    event.preventDefault()
    if (!this.urlValue) return

    // Existierendes Dialog wiederverwenden oder neu erstellen
    let dialog = document.getElementById("dialog-loader-modal")
    if (!dialog) {
      dialog = document.createElement("dialog")
      dialog.id = "dialog-loader-modal"
      dialog.className = "rounded-xl shadow-2xl border-0 p-0 w-full max-w-lg backdrop:bg-black/40 backdrop:backdrop-blur-sm"
      dialog.addEventListener("click", (e) => {
        // Backdrop-Klick schließt (click auf dialog selbst, nicht auf Inhalt)
        if (e.target === dialog) dialog.close()
      })
      dialog.addEventListener("close", () => {
        dialog.innerHTML = ""
      })
      document.body.appendChild(dialog)
    }

    // Loading-State
    dialog.innerHTML = `
      <div class="flex items-center justify-center p-12">
        <div class="animate-spin h-8 w-8 border-4 border-indigo-500 border-t-transparent rounded-full"></div>
      </div>
    `
    dialog.showModal()

    // Content laden
    fetch(this.urlValue, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`)
        return r.text()
      })
      .then((html) => {
        dialog.innerHTML = `
          <div class="relative">
            <button type="button" class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors z-10"
                    onclick="this.closest('dialog').close()">
              <i class="fas fa-times text-lg"></i>
            </button>
            <div class="p-6">${html}</div>
          </div>
        `
      })
      .catch((err) => {
        dialog.innerHTML = `
          <div class="p-6 text-center">
            <p class="text-red-500 text-sm mb-3">Fehler beim Laden</p>
            <p class="text-gray-400 text-xs">${err.message}</p>
            <button type="button" class="mt-4 text-sm text-gray-500 hover:text-gray-700 underline"
                    onclick="this.closest('dialog').close()">Schließen</button>
          </div>
        `
      })
  }
}
